﻿import React from 'react';
import { FormField } from '../inputs/FormField';
import { SelectInput, SelectOption } from '../inputs/SelectInput';
import { CommonFieldProps } from './CommonFieldProps';

interface LocaleFieldsProps extends CommonFieldProps {
    isoLocales: SelectOption[];
}

export const LocaleFields: React.FC<LocaleFieldsProps> = ({ formik, getFieldError, hasError, isoLocales }) => {
    const selectedNewLocaleOption = isoLocales.find(opt => opt.value === formik.values.newLocaleCode) || null;
    
    return (
        <div>
            <h2 className="h4 mb-3">Region / Locale Details</h2>
           
            <FormField
                label="Select Region"
                required
                helpText="Select the country or region you'd like us to support"
                htmlFor="newLocaleCode"
                error={getFieldError('newLocaleCode')}
            >
                <SelectInput
                    inputId="newLocaleCode"
                    value={selectedNewLocaleOption}
                    onChange={(option: SelectOption | null) => formik.setFieldValue('newLocaleCode', option?.value || '')}
                    options={isoLocales}
                    placeholder="Select a region"
                    isClearable
                    isSearchable
                    hasError={hasError('newLocaleCode')}
                />
            </FormField>
        </div>
    );
};
